import { Component } from '@angular/core';
import { MENU } from '../../data/menu.data';
import { Menu } from '../../models/menu.model';
import { SlideMenuService } from '../../services/slide-menu.service';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss'
})
export class DashboardLayoutComponent {

  public menu: Array<Menu> = MENU;
  public sidebarCollapsed = false;

  constructor(
    public slideMenuService: SlideMenuService
  ) {
  }

}
